const TermDoc = () => {

  return <>
    <div>
      제1조(목적)<br/>
      이 약관은 주식회사 레이(이하 “회사”)가 운영하는 RAYTeams(이하”플랫폼”)에서 무료로 제공하는 서비스(이하 “서비스”)를 이용함에 있어 플랫폼과 회원의 권리, 의무 및 책임사항, 서비스 이용조건 및 절차 등 기본적인 사항을 규정함을 목적으로 합니다.이 약관은 회원과 회사 사이에 체결된 계약으로 회원의 플랫폼 이용에 적용됩니다. 다음 계약조건을 읽고 숙지하시기 바라며, 귀하가 세부 계약 조건에 대하여 명확한 이해를 토대로 “동의”를 클릭함으로써 귀하가 서비스에 접속하거나 이를 이용하는 경우, 본 약관이 적용된다는 사실에 관하여 귀하는 명시적으로 동의하게 됩니다.회사는 플랫폼 서비스 제공자로서 본 약관에 기재된 계약조건들에 따라 귀하가 귀하의 업무 컨텐츠(예를 들어, 귀하의 이름 및 소속기관명, 주소, 직업, 연락처, 이메일, 비밀번호 및 환자의 스캔데이터, 해당 서비스 이용 시 회원 간 계약이행을 위해 상대방에게 전달되는 메모사항 및 채팅 등의 부가 정보)를 저장하고 이를 이용하도록 허
      임사항, 서비스 이용조건 및 절차 등 기본적인 사항을 규정함을 목적으로 합니다.이 약관은 회원과 회사 사이에 체결된 계약으로 회원의 플랫폼 이용에 적용됩니다. 다음 계약조건을 읽고 숙지하시기 바라며, 귀하가 세부 계약 조건에 대하여 명확한 이해를 토대로 “동의”를 클릭함으로써 귀하가 서비스에 접속하거나 이를 이용하는 경우, 본 약관이 적용된다는 사실에 관하여 귀하는 명시적으로 동의하게 됩니다.회사는 플랫폼 서비스 제공자로서 본 약관에 기재된 계약조건들에 따라 귀하가 귀하의 업무 컨텐츠(예를 들어, 귀하의 이름 및 소속기관명입니다.
      나 이를 이용하는 경우, 본 약관이 적용된다는 사실에 관하여 귀하는 명시적으로 동의하게 됩니다.회사는 플랫폼 서비스 제공자로서 본 약관에 기재된 계약조건들에 따라 귀하가 귀하의
      나 이를 이용하는 경우, 본 약관이 적용된다는 사실에 관하여 귀하는 명시적으로 동의하게 됩니다.회사는 플랫폼 서비스 제공자로서 본 약관에 기재된 계약조건들에 따라 귀하가 귀하의
    </div>
  </>
};

export default TermDoc;
